<script setup lang="ts">
import './assets/style.scss'
import { useConfirm, VIcons } from '@/shared/ui'
import type { PropType } from 'vue'
import type { ObjectTypeGroup } from '@/entities/Inventory/ObjectSubTypes'
import { useTranslate } from '@/shared/lib'
import { useRemoveInventObjectGroup } from './../model/api.ts'

const props = defineProps({
  group: {
    type: Object as PropType<ObjectTypeGroup>,
    required: true,
  },
})

const { show } = useConfirm()
const { trs } = useTranslate()
const { remove, isPending } = useRemoveInventObjectGroup()

const emits = defineEmits(['removed'])

/**
 * Функция удаления группы
 */
const clickHandler = () => {
  if (!props.group) return

  show({
    title: trs('itf.confirm_remove_group', { name: props.group.name }),
    confirmFunc: () =>
      remove({ id: props.group.id }).then(() => {
        emits('removed')
      }),
  })
}
</script>

<template>
  <VTooltip location="top" :open-delay="500" :text="$t('itf.delete')">
    <template #activator="{ props: tooltipProps }">
      <VBtn
        :loading="isPending"
        color="error"
        density="compact"
        icon
        v-bind="tooltipProps"
        @click="clickHandler"
      >
        <VIcons type="delete" />
      </VBtn>
    </template>
  </VTooltip>
</template>
